<template>
    <teleport to="body">
        <div class="modal-dialog" :class="{ 'is-open': isOpen }" ref="modalDialog">
            <div class="modal-container" v-show="isOpen">
                <div class="modal-content">
                    <div class="modal-header">
                        <img
                            :src="`https://${domain}/templates/Goya/assets/images/logo.svg`"
                            class="logo-black mx-auto"
                        >
                        <a @click="isOpen = false"><i class="icon-close"></i></a>
                    </div>
                    <div class="modal-item py-ml px-ml">
                        <!-- loader -->
                        <div v-if="isLoading" class="text-center mt-10 mb-10">
                            <div class="loader"></div>
                        </div>
                        <component
                            v-else-if="isOpen"
                            :is="currentStepComponent"
                            @success="isAuth = true"
                        />
                    </div>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>

import LoginForm from './Login.vue'
import GrantForm from './Grant.vue'

const BTN = '.claim';

export default {
    name: "ModalPopUp",
    components: { LoginForm, GrantForm },
    data() {
        return {
            isOpen: false,
            isLoading: false,
            _globalClickHandler: false,
            isAuth: false, // авторизован клиент или нет
        }
    },
    mounted() {
        this._globalClickHandler = (e) => {
            const btn = e.target.closest('.claim');
            if (btn) {
                e.preventDefault();
                this.init();
            }
        };
        document.addEventListener('click', this._globalClickHandler);
        this.hasParam();
    },
    beforeUnmount() {
        document.removeEventListener('click', this._globalClickHandler)
        document.body.style.overflow = '';
        this.isLoading = false
    },
    computed: {
        domain() {
            return window.location.hostname.replace(/^www\./, '')
        },
        currentStepComponent() {
            return this.isAuth ? 'GrantForm' : 'LoginForm';
        },
    },
    watch: {
        isOpen(val) {
            document.body.style.overflow = val ? 'hidden' : '';
        }
    },
    methods: {
        hasParam() {
            // есть ли параметры в ссылке?
            const params  = new URLSearchParams( window.location.search );
            const n = params.get('n');
            if( n ) {
                this.init()
            }
        },
        async init() {

            if( this.isOpen )
                return;

            this.isOpen = true;
            this.isLoading = true;

            try {
                const response = await this.$http.post('/auth/hasAccount', {}, { timeout: 5000 })
                if( ! response || ! response.data ) {
                    console.log('Invalid response');
                    return;
                }

                const { status, data } = response.data;
                if( status === 'error' || !['success', 'error'].includes( status ) ) {
                    console.log( data.message || 'Unknown error from server' );
                    return;
                }

                this.isAuth = data.status;
            } catch ( err ) {
                console.log('Request cancelled:', err.message);
            } finally {
                this.isLoading = false;
            }
        },
    }
}
</script>

<style scoped>

</style>